/**
 * Calendar Plan Ending Trigger Component
 *
 * Trigger: "calendar plan ending soon"
 * No additional fields needed - timing is handled at card level.
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TriggerComponentProps } from '../automationTriggers';

export const CalendarPlanEndingTrigger: FC<TriggerComponentProps> = ({
  readOnly,
}) => {
  const { t } = useTranslation();

  if (readOnly) {
    return <span>{t('automations.triggers.calendarPlanEnding')}</span>;
  }

  // Edit mode - no additional fields, timing handled at card level
  return null;
};
